<!--
Map builder publication admin screen.
@author crm4f
-->

<template>
  <div class="publicationAdminContainer">

    <div class="publicationOptionsContainer">
      <div class="btn-group" role="group" aria-label="newItemOptions">
        <button type="button" class="btn btn-primary active btn-sm" @click="publish()">Publish</button>
        <button type="button" class="btn btn-primary active btn-sm" @click="rollBack()">Roll back</button>
      </div>
    </div>

    <div class="gmapContainer">
      <h3 style="text-align: left;">Preview</h3>
      <p style="text-align: left;">This map shows unpublished data for Show features. Get directions still uses published data.</p>
      <iframe id='previewFrame' src="/map/#/?preview=true" title="UofG Interactive Map" width="100%" height="100%"></iframe>
    </div>

  </div>
</template>
    
<script setup>
import axios from 'axios'

function publish () {
  if(confirm("Are you sure you want to publish all changes?")) {
    axios.post("map/admin/publication")
      .then((response) => {
        if (response.status == 200) {
          alert("Publication complete.") 
        } else if (response.status == 401 || response.status == 403) {
          alert('You are not authenticated. Check console for details.')
        } else {
          alert('Something unexpected happened. Check console for details')
        }
    })
  }    
}

function rollBack () {
  if(confirm("Are you sure you want to roll back all changes?")) {
    axios.delete("map/admin/publication")
      .then((response) => {
        if (response.status == 200) {
          alert("Roll back complete.")
        } else if (response.status == 401 || response.status == 403) {
          alert('You are not authenticated. Check console for details.')
        } else {
          alert('Something unexpected happened. Check console for details')
        }
        document.getElementById('previewFrame').contentDocument.location.reload(true)    
    })
  }  
}

</script>
  
<style scoped>
.publicationAdminContainer {
  display: flex;
  height: 100vh;
}

.publicationOptionsContainer {
  padding: 25px 0px 10px 10px;
}

.gmapContainer {
  color: #003865;
  width: 100%;
  padding: 20px;
}
.mapViewContainer {
  display: flex;
}

.mapControls {
  width: 25%;
  padding: 25px 10px 10px 10px;
}

.listHeader {
  color: #003865;
  font-weight: bold;
}

.hrhalfheight {
  width: 75%;
  margin: auto;
}

.feature-list {
  margin-bottom: 15px;
}

.showFeatures, .showFeatures button {
  width: 100%;
}

.featuresContainer {
  margin-top: 15px;
}

.optionRow {
  display: flex;
  margin: 10px 0px 0px 5px;
  align-items: center;
  justify-content: space-between;
}

.optionRow > :nth-child(1) {
  margin-right: 15px;
  width: 25%;
  text-align: left;
  word-break: break-word;
  font-size: 13px;
  font-weight: bold;
}

.optionRow > :nth-child(2) {
  flex: 1;
  width: 100% !important;
}

</style>